import { AppServicesProvider } from "./presentation/hooks/AppContext.tsx";
import { useStorageStatus } from "./presentation/hooks/bindings.ts";
import { AppRoutes } from "./presentation/routes/AppRoutes.tsx";
import { RecoveryScreen } from "./presentation/screens/RecoveryScreen.tsx";
import { isUsableStorageStatus } from "./application/ports/storage.ts";
import type { AppServices } from "./application/appServices.ts";

export function App({ services }: { services: AppServices }) {
  return (
    <AppServicesProvider services={services}>
      <AppShell />
    </AppServicesProvider>
  );
}

function AppShell() {
  const status = useStorageStatus();
  if (isUsableStorageStatus(status)) {
    return <AppRoutes />;
  }
  return <RecoveryScreen />;
}
